import React, { useEffect, useState } from "react";
import FutureSelfSpotlight from "@/components/FutureSelfSpotlight";
import { AppHeader } from "@/components/AppHeader";
import { useNavigationHistory } from "@/hooks/useNavigationHistory";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useEditableContent } from "@/hooks/useEditableContent";
import { supabase } from '@/integrations/supabase/client';
import { User } from '@supabase/supabase-js';

export default function FutureSelfNavigator() {
  const [user, setUser] = useState<User | null>(null);
  const { goBack, getBackButtonLabel } = useNavigationHistory();
  
  const pageTitle = useEditableContent('futureself.page.title', 'Future Self Navigator', 'Future Self');
  const backButtonPrefix = useEditableContent('futureself.back.prefix', 'Back to', 'Future Self');
  
  useEffect(() => {
    document.title = "Future Self Navigator - Timeline Navigation System | Therappi";
    
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      setUser(session?.user ?? null);
    });
    
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleSignOut = async () => {
    await supabase.auth.signOut();
  };

  return (
    <div className="min-h-screen bg-background">
      <AppHeader user={user} onSignOut={handleSignOut} />
      <div className="container mx-auto px-4 py-6">
        <Button 
          variant="outline" 
          onClick={goBack}
          className="mb-4 gap-2"
        >
          <ArrowLeft className="h-4 w-4" />
          {backButtonPrefix} {getBackButtonLabel()}
        </Button>
        <div className="text-center mb-6">
          <div className="inline-block px-3 py-1 mb-3 text-xs font-medium bg-primary/20 text-primary rounded-full">
            FUTURE TIMELINE
          </div>
          <p className="text-sm text-muted-foreground max-w-2xl mx-auto">
            The <span className="text-primary font-medium">Future Timeline</span> is where you consciously construct who you are becoming.
          </p>
        </div>
        <FutureSelfSpotlight standalone={true} />
      </div>
    </div>
  );
}
